import { Link } from "react-router";
import { BarChart3, ChevronRight } from "lucide-react";
import PageShell from "../../components/dashboard/PageShell";
import { PROVIDER_REPORTS, reportPath } from "../../config/providerReports";

export default function ReportsPage() {
  return (
    <PageShell
      title="Reports"
      description="Portfolio, recovery, and reconciliation reports for your institution."
    >
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {PROVIDER_REPORTS.map((report) => (
          <Link
            key={report.slug}
            to={reportPath(report.slug)}
            title={report.purpose}
            className="group rounded-xl border border-primary/[0.07] bg-white p-5 shadow-[0_1px_2px_rgba(127,29,29,0.04)] transition-all hover:border-primary/15 hover:shadow-md"
          >
            <span className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-primary/[0.06] text-primary">
              <BarChart3 className="h-5 w-5" />
            </span>
            <h2 className="text-sm font-bold text-primary group-hover:text-collect">{report.name}</h2>
            <p className="mt-1.5 text-xs leading-relaxed text-primary/50">{report.purpose}</p>
            <span className="mt-3 inline-flex items-center gap-1 text-[11px] font-semibold text-collect">
              Open report
              <ChevronRight className="h-3.5 w-3.5" />
            </span>
          </Link>
        ))}
      </div>
    </PageShell>
  );
}
